<template>
	<div class="filter">
		<h3 class="filter-header text-uppercase">Filtros</h3>
		<div class="filter-price">
			<h4 class="text-uppercase">Precio</h4>
			<div class="slider"></div>
			<div class="col-sm-4 text-center no-padding">
				<input class="form-control lower-handle">
			</div>
			<div class="col-sm-4 text-center">
				<p class="text-padding-sm"> hasta </p>
			</div>
			<div class="col-sm-4 text-center no-padding">
				<input class="form-control higher-handle">
			</div>
		</div>	
	</div>
</template>

<style scoped>
	input {
		font-family: 'Montserrat';
	}
</style>

<script>
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import { router } from '../../routes/routes';
import { filterPrice } from '../../store/actions';

export default {
	data() {
		return {};
	},

	vuex: {
		getters: {
			min_price: state => state.min_price,
			max_price: state => state.max_price,
		},

		actions: {
			filterPrice
		}
	},

	methods: {
		initSlider() {
			var money_format = wNumb({
				decimals: 0,
				prefix: '$ '
			});
			// get the element to bind the slider.
			let $slider = document.querySelector('.slider');
			let $lower_handle = document.querySelector('.lower-handle');
			let $higher_handle = document.querySelector('.higher-handle');

			$($lower_handle).on('keydown', e => {
				if (e.keyCode == 13) {
					let formated = money_format.from(e.target.value).toString();
					$slider.noUiSlider.set([e.target.value, null]);
					this.filterPrice(formated, null);
					router.go(this.getRoute());
				}
			});

			$($higher_handle).on('keydown', e => {
				if (e.keyCode == 13) {
					let formated = money_format.from(e.target.value).toString();
					$slider.noUiSlider.set([null, e.target.value]);
					this.filterPrice(null, formated);
					router.go(this.getRoute());
				}
			});
			
			// create the slider.
			noUiSlider.create($slider, {
				start: [1, 50000],
				range: {
					min: 1,
					max: 50000
				},
				format: money_format
			});
			
			// update the div with the value. 
			$slider.noUiSlider.on('update', (val, handle) => {
				if (handle) {
					let val_right = val[handle].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
					$higher_handle.value = val_right;
				} else {
					let val_left = val[handle].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
					$lower_handle.value = val_left;
				}
			});
			
			// update filter when the slide has change.
			$slider.noUiSlider.on('change', (val, handle) => {
				let formated_1 = money_format.from(val[0]).toString();
				let formated_2 = money_format.from(val[1]).toString();

				this.filterPrice(formated_1, formated_2);
				router.go(this.getRoute());
			});
		},


		getRoute () {
			let route_name = this.$route.name;

			if (route_name == 'search_results')
				route_name = 'resultados';

			var route = `/${ route_name }?`;

			// If has page query.
			if (this.$route.query.page)
				route += `page=1`;

			if (this.$route.query.page && this.$route.query.filter)
				route += '&';

			// If has filter query.
			if (this.$route.query.filter)
				route += `filter=${ this.$route.query.filter }`;

			if (this.$route.query.page && this.$route.query.search)
				route += '&';

			if (this.$route.query.search)
				route += `search=${ this.$route.query.search }`;

			/**
			 * Filter Selections (SHIT CODE)
			 * -----------------------------
			 * If the route has a param selection make the route
			 * for selections.
			 */

			if (this.$route.params.selections) {
				route = '/selecciones'
				route = route.split('?')[0] + '/' + this.$route.params.selections
			}

			return route;
		},

		resetPrice () {
			// router.afterEach(transition => {
			// 	this.filterPrice('0.00', 50000);
			// });
		},

		handlePrices () {
			$('.lower-handle').on('input', function () {
				var $this = $(this);
				var num = $this.val().replace(/(,)/g, '');
				$this.val(num.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"));
			});

			$('.higher-handle').on('input', function () {
				var $this = $(this);
				var num = $this.val().replace(/(,)/g, '');
				$this.val(num.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"));
			});
		}
	},

	ready() {
		this.initSlider();
		this.resetPrice();
		this.handlePrices();
	}
}
</script>


// WEBPACK FOOTER //
// Filter.vue?15e4b6fb